import * as React from "react";
import { ArrowRight, Camera, Mic, Zap, FileVideoCamera, Layers } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const servicesData = [{
  title: "Aerial Photography Suite",
  description: "High-resolution aerial stills capturing the stunning landscape and architectural beauty of your course from unique, cinematic angles.",
  price: "$300 or bundled",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/aerial_photography_suite.png",
  icon: Camera,
  link: "/RequestAQuotePage"
}, {
  title: "Yardage & Hazard Graphics Bundle",
  description: "Precision-mapped overlays for every hole, providing golfers with accurate distances to hazards, bunkers, and greens for a professional feel.",
  price: "$700",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/yardage_hazard_graphics.png",
  icon: Layers,
  link: "/RequestAQuotePage"
}, {
  title: "Rush Editing (48-hour turnaround)",
  description: "Need your content fast? Our rush service guarantees a 48-hour turnaround for your completed media assets.",
  price: "$200",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/rush_editing_48h.png",
  icon: Zap,
  link: "/RequestAQuotePage"
}, {
  title: "Raw Footage Delivery (4K unedited clips)",
  description: "Receive all unedited 4K drone clips from the shoot for your own internal marketing or archival use.",
  price: "$500",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/raw_4k_footage.png",
  icon: FileVideoCamera,
  link: "/RequestAQuotePage"
}];
export default function Services() {
  return <section data-section-id="245009" id="build-your-own-media-kit" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-3xl text-center mb-12 md:mb-16">
          <Badge variant="secondary" className="mb-4 bg-secondary text-secondary-foreground font-default uppercase tracking-widest">
            Premium services to elevate your package
          </Badge>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Optional Enhancements
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Take your media further. Add premium enhancements to any package to create a truly customized solution. Every enhancement is designed to extend reach, add production value, and serve specific course marketing goals.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {servicesData.map((service, index) => <Card key={index} data-index={index} className="flex flex-col overflow-hidden border-border bg-card shadow-lg hover:shadow-xl transition-shadow duration-300">
              <AspectRatio ratio={16 / 9}>
                <img src={service.image} data-wvc-srcset={`${service.image}-wvc-srcset`} data-wvc-sizes={`${service.image}-wvc-sizes`} alt={service.title} className="object-cover w-full h-full grayscale hover:grayscale-0 transition-all duration-500" loading="lazy" />
              </AspectRatio>
              <CardHeader className="pb-4">
                <div className="flex justify-between items-start mb-4">
                  <div className="w-12 h-12 rounded-lg bg-primary/20 flex items-center justify-center text-primary">
                    <service.icon className="w-6 h-6" />
                  </div>
                  
                </div>
                <CardTitle className="font-default text-xl text-foreground">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="flex-grow pb-6">
                <p className="text-muted-foreground leading-relaxed font-default">
                  {service.description}
                </p>
              </CardContent>
              <CardFooter className="pt-0 mt-auto">
                <Button asChild variant="outline" className="w-full group border-primary text-primary hover:bg-primary hover:text-primary-foreground rounded-md">
                  <Link to={service.link}>
                    Add Enhancement
                    <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" />
                  </Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>

        <div className="mt-12 text-center">
          <Button asChild size="lg" className="px-8 bg-primary text-primary-foreground hover:bg-primary/90 rounded-md font-default">
            <Link to="/RequestAQuotePage">
              Request Custom Quote
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}